export const EVENT = {
    UNLOCK_BY_STAFF: 'UNLOCK_BY_STAFF',
    BANNER_UPDATE: 'BANNER_UPDTAE',
    GROUP_COUNT_ERROR: 'GROUP_COUNT_ERROR',
    PERMISSION_DENIED_TO_MAIN_COMPONENT: 'PERMISSION_DENIED_TO_MAIN_COMPONENT',
    GROUP_ERROR: 'GROUP_ERROR',
    AUTH_TOKEN_INFO: 'AUTH_TOKEN_INFO',
    COMPONENT_NOT_FOUND: 'COMPONENT_NOT_FOUND',
    CONFIG_MISMATCH: 'CONFIG_MISMATCH',
    LOGIN: 'LOGIN',
    INSERT: 'INSERT',
    UPDATE: 'UPDATE'
};

export const LOGTYPE = {
    INFO: 'INFO',
    ERROR: 'ERROR',
    WARNING: 'WARNING',
    DEBUG: 'DEBUG',
    CRITICAL: 'CRITICAL'
};


